import { Typography, ListItem, Box, useTheme, Stack } from "@mui/material";
import { Link } from "react-router-dom";
import Person2Icon from "@mui/icons-material/Person2";

interface ProfileCardProps {
  item: {
    name: string;
    affiliate_title: string;
    country_code: string;
    profile_img_url?: string;
    personal_website: string;
    affiliate?: string;
  };
}

const ProfileCard: React.FC<ProfileCardProps> = ({ item }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        maxWidth: "100%",
        width: '100%',
      }}>
      <Box sx={{ marginBottom: { md: "15px", xs: "10px" }, }}>
        <img
          className="profile-pic"
          src={item.profile_img_url || "/profile.png"}
          alt=""
          style={{
            objectFit: "cover",
            borderRadius: '15px',
            backgroundColor: "#fff",
            width: "100%",
            aspectRatio: "1 / 1",
          }}
        />
      </Box>
      <Typography sx={{
        fontSize: { lg: "24px", md: "22px", xs: "20px" },
        fontWeight: '600',
        color: theme.customColors.primary.prusianBlue,
        lineHeight: '1.4'
      }} variant="h4"> <Link
        to={item.personal_website.includes('\/\/') ? item.personal_website : `\/\/${item.personal_website}`}
        target="_blank"
        style={{ color: theme.customColors.primary.prusianBlue }}
      >{item.name} ({item.country_code}) </Link>
      </Typography>

      {/* <Typography variant="h4" style={{ margin: 0, fontWeight: 500 }}>
        {item.affiliate_title}
      </Typography> */}

      {item.affiliate && (
        <Typography sx={{
          fontSize: { lg: "22px", md: "20px", xs: "18px" }, fontWeight: '500',
          color: theme.customColors.primary.prusianBlue, fontStyle: 'italic'
        }}
        >
          {item.affiliate}
        </Typography>
      )}
    </Box>
  );
};

export default ProfileCard;
